module.exports = __webpack_public_path__ + "img/google-grayscale.36df1a7.svg";